import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EmpleadosServicio } from '../../../services/empleado.service';
import { CuadreService } from '../../../services//cuadre.service';
import { AlertasModales } from '../../../helpers/alertasModales';
@Component({
  selector: 'app-detalle-apertura',
  templateUrl: './detalle-apertura.component.html',
  styleUrls: ['./detalle-apertura.component.css']
})
export class DetalleAperturaComponent implements OnInit {
  @Input() apertura: any;
  @Input() modals: AlertasModales;
  capital = '';
  nota = '';
  ruteros = [];
  ruteroSeleccionado;
  loading = false;
  constructor(
    public activeModal: NgbActiveModal,
    private empleadoService: EmpleadosServicio,
    private cuadreService: CuadreService) {
    this.initRuteros();
  }

  ngOnInit() {
    this.ruteroSeleccionado = this.apertura.entregadoA;
  }

  private initRuteros(): void {
    this.empleadoService.listaEmpleado('2').subscribe(res => this.ruteros = res.empleados);
  }

  public anadirCapital() {
    if (this.capital) {
      const data = {
        capital: parseFloat(this.capital),
        nota: this.nota,
        ID_EMPLEADO: this.apertura.ID_EMPLEADO,
        entregadoA: this.ruteroSeleccionado,
        ID_APERTURA_DIA: this.apertura.ID_APERTURA_DIA,
        ruta: this.apertura.ruta,
        ID_RUTA: this.apertura.ID_RUTA
      };
      this.loading = true;
      this.cuadreService.anadirCapital(data).subscribe(() => {
        setTimeout(() => this.loading = false, 1);
        this.activeModal.close(data);
      }, err => {
        this.loading = false;
        if (err.status == 403) {
          this.modals.validacionesModalJquery('No tienes permisos para realizar esta operación', '',
          'red',
          'modern',
          false,
          'fa fa-file-text');
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/modals/detalle-apertura/detalle-apertura.component.ts